import { getConceptCodes } from "@intocare/datatypes/lib/code-system";
import { composeValueSet } from "@intocare/datatypes/lib/value-set";

import { OBSERVATION_CAUSE } from "../../code-system/observation-cause";

export const OBSERVATION_CAUSE_DISPLAY = composeValueSet({
	name: "OBSERVATION_CAUSE_DISPLAY",
	description: "Current selection of causes for displaying observations.",
	system: OBSERVATION_CAUSE,
	include: getConceptCodes(OBSERVATION_CAUSE),
});
